import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const cMChannelsApi = createApi({
  reducerPath: 'cMChannelsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['CustomerChannels'],
  endpoints: builder => ({
    getCustomerChannels: builder.query({
      query: (params) => ({
        url: `/customers/customer-channels/`,
        params,
      }),
      providesTags: ['CustomerChannels']
    }),
    addCustomerChannels: builder.mutation({
      query: ({ serviceData }) => ({
        url: `/customers/customer-channels/`,
        method: 'POST',
        body: serviceData
      }),
      invalidatesTags: ['CustomerChannels']
    }),
    getCustomerChannelsByCustomerId: builder.query({
      query: ({ customerId, params }) => ({
        url: `/customers/customer-channels/${customerId}`,
        method: 'GET',
        params: params
      }),
      providesTags: ['CustomerChannels']
    }),
    updateCustomerChannels: builder.mutation({
      query: ({ id, serviceData }) => ({
        url: `/customers/customer-channels/${id}/`,
        method: 'PUT',
        body: serviceData
      }),
      invalidatesTags: ['CustomerChannels']
    }),
    
  })
})

export const {
  useGetCustomerChannelsQuery,
  useGetCustomerChannelsByCustomerIdQuery,
  useAddCustomerChannelsMutation,
  useUpdateCustomerChannelsMutation,
} = cMChannelsApi
